<div class="divPrincipal">
  <!-- <table class="tabelaHorarios">
    <thead>
      <tr>
        <th>Horários</th>
      </tr>
    </thead>
    <tbody>
      
      <tr *ngFor="let horario of horarios">
        <td class="horarios">{{ horario }}</td>
      </tr>
    </tbody>
  </table> -->

  <table class="tabelaVeiculos">
    <thead>
      <!-- <tr>
        <th>Horários</th>
      </tr> -->
      <tr class="titulos">
        <th class="horarios">Horários</th>
        <th class="areaNomes" *ngFor="let area of areas">
          <div>{{ area.nome }}</div>
        </th>
      </tr>
    </thead>
    <tbody>
      <!-- <tr *ngFor="let horario of horarios">
        <td class="horarios">{{ horario }}</td>
      </tr> -->
      <tr *ngFor="let horario of horarios">
        <td class="horarios">{{ horario }}</td>
        <td *ngFor="let area of areas">
          <!-- <div class="areasDescarga">
            <td class="docasDescarga" *ngFor="let doca of area.docas">
                <div  [attr.rowspan]="3" *ngIf="getEventoParaDocaEHorario(doca.id, horario) as evento"
                [ngStyle]="getEstiloEvento(evento)">
             {{ evento?.veiculo }} 
            </div>
            </td>        
          </div> -->
          <div class="areasDescarga">
        <td class="docasDescarga" *ngFor="let doca of area.docas">
          <div *ngIf="shouldDisplayEvento(doca.id, horario) as evento" [ngStyle]="{ 'height': getRowSpanHeight(evento),
            'color': 'white',
            'padding': '5px',
            'border-radius': '5px',
            'width': '45px',
            'background-color': 'green'}">
            {{ evento?.veiculo }}
          </div>
          <!-- <div *ngIf="shouldDisplayEvento(doca.id, horario) as evento" [ngClass]="getRowSpanClass(evento)"
            [ngStyle]="getEstiloEvento(evento)">
            {{ evento?.veiculo }}
          </div> -->
        </td>
</div>
</td>
</tr>
</tbody>
</table>
</div>



<!--   
  <table>
    <thead>
      <tr>
        <th>Horários</th>
        <th *ngFor="let area of areas">
          <div>{{ area.nome }}</div> 
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let horario of horarios">
        <td>{{ horario }}</td>
        <td *ngFor="let area of areas">
          <ng-container *ngFor="let doca of area.docas">
            <ng-container *ngIf="shouldDisplayEvento(doca.id, horario) as evento">
              <td *ngIf="evento" [attr.rowspan]="getRowSpan(evento)" [ngStyle]="getEstiloEvento(evento)">
                {{ evento?.veiculo }}
              </td>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table> -->